import { render, staticRenderFns } from "./SelectedCompany.vue?vue&type=template&id=2ae9eabe"
import script from "./SelectedCompany.vue?vue&type=script&lang=js"
export * from "./SelectedCompany.vue?vue&type=script&lang=js"
import style0 from "./SelectedCompany.vue?vue&type=style&index=0&id=2ae9eabe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports